import React from 'react'
import { Outlet } from 'react-router-dom';

export default function ApplicantsLayout() {
  return (
    <div>
        <Outlet />
    </div>
  )
}
